






































































import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
import MaintainRecordDto from '@/store/models/maintain/maintainrecord'
@Component({})
export default class DispatchDetail extends VueBase {
	id!: any
	titletext: string = ''
	loading: boolean = false
	isNew: boolean = false
	dispatchFormData: MaintainRecordDto = new MaintainRecordDto()
	showSchool: boolean = false
	schoolList: Array<any> = []
	showVehicle: boolean = false
	vehicleList: Array<any> = []
	vehicleShortNO: string = ''
	showAcceptanceTime: boolean = false
	showContactReason: boolean = false
	commonQuestionList: Array<any> = [{ 'text': '', 'check': false }]
	contactReasons: any = []
	showDispatchTime: boolean = false
	showAssignBy: boolean = false
	assignByList: Array<any> = []
	assignBys: any = []
	showHandleType: boolean = false
	showMaintainRecordType: boolean = false
	maintainRecordTypeName: string = ''

	handleTypes = [
		{ value: '现场处理', text: '现场处理' },
		{ value: '远程处理', text: '远程处理' },
		{ value: '电话沟通', text: '电话沟通' },
	]

	handleChangeTypes = [
		{ value: '驾培', text: '驾培' },
		{ value: '驾考', text: '驾考' },
		{ value: '其他', text: '其他' },
	]

	onClickLeft() {
		window.history.go(-1)
	}
	async getSchoolList() {
		await ajax.get('/api/school/school-to-drop-down')
			.then(rep => {
				this.schoolList.push(...rep.data.result)
			})
	}
	async getVehicleList(schoolcode: string) {
		await ajax.get('/api/vehicle/vehicle-to-drop-down/' + schoolcode)
			.then(rep => {
				this.vehicleList.push(...rep.data.result)
			})
	}
	async getCommonQuestionList() {
		this.commonQuestionList = []
		let isvehicle = false
		if (this.dispatchFormData.vehicleNO)
			isvehicle = true
		else
			isvehicle = false
		await ajax.get('/api/maintainrecord/common-question-list/' + isvehicle)
			.then(rep => {
				// this.commonQuestionList.push(...rep.data.result)
				rep.data.result.forEach((t: any) => {
					let res = {
						text: t,
						check: false,
					}
					this.commonQuestionList.push(res)
				})
			})
	}
	async getAssignByList() {
		await ajax.get('/api/maintainrecord/assign-by-list')
			.then(rep => {
				this.assignByList.push(...rep.data.result)
			})
	}
	async getById(id: any) {
		await ajax.get('/api/maintainrecord/by-id-wx/' + id)
			.then(rep => {
				Object.assign(this.dispatchFormData, rep.data.result)

				if(this.dispatchFormData.maintainRecordType==10) {
					this.maintainRecordTypeName = '驾培'
				} else if (this.dispatchFormData.maintainRecordType==20) {
					this.maintainRecordTypeName = '驾考'
				} else if (this.dispatchFormData.maintainRecordType==30) {
					this.maintainRecordTypeName = '其他'
				}
			})
		// if (this.dispatchFormData.contactReasons.length > 0) {
		// 	this.contactReasons = this.dispatchFormData.contactReasons
		// }
	}
	async getVehicleShortNO() {
		await ajax.get('/api/vehicle/vehicle-short-no')
			.then(rep => {
				this.vehicleShortNO = rep.data.result
			})
	}
	async onConfirmSchool(val: any) {
		this.dispatchFormData.schoolShortName = val.shortName
		this.dispatchFormData.schoolCode = val.schoolCode
		// this.vehicleList = []
		// this.dispatchFormData.vehicleNO = null
		// await this.getVehicleList(val.schoolCode)
		this.showSchool = false
	}
	async onConfirmVehicle(val: any) {
		this.dispatchFormData.vehicleNO = val.vehicleNO
		this.showVehicle = false
		await this.getCommonQuestionList()
	}
	onConfirmAcceptanceTime(val: any) {
		this.dispatchFormData.acceptanceTime = util.formatDateTime(val)
		this.showAcceptanceTime = false
	}
	onConfirmContactReason() {
		this.dispatchFormData.contactReasons = this.contactReasons
		this.dispatchFormData.contactReason = this.contactReasons.join(',')
		this.showContactReason = false
	}
	onConfirmDispatchTime(val: any) {
		this.dispatchFormData.dispatchTime = util.formatDateTime(val)
		this.showDispatchTime = false
	}
	onConfirmAssignBy() {
		this.dispatchFormData.assignBys = this.assignBys
		this.dispatchFormData.assignBy = this.assignBys.join(',')
		this.showAssignBy = false
	}
	onConfirmHandleType(val: any) {
		this.dispatchFormData.handleType = val.value
		this.showHandleType = false
	}
    
	onConfirmMaintainRecordType(val: any) {
		console.log('onConfirmMaintainRecordType',val.value)
		if(val.value==='驾培') {
			this.dispatchFormData.maintainRecordType = 10
		} else if(val.value==='驾考') {
			this.dispatchFormData.maintainRecordType = 20
		} else if(val.value==='其他') {
			this.dispatchFormData.maintainRecordType = 30
		}
		this.maintainRecordTypeName = val.value
		this.showMaintainRecordType = false
	}

	async onSubmit() {
		this.loading = true
		if (this.isNew) {
			await ajax.post('/api/maintainrecord/wx', this.dispatchFormData)
				.then(() => {
					this.$toast.success('保存成功')
					window.history.back()
				})
				.finally(() => {
					this.loading = false
				})
		} else {
			await ajax.post('/api/maintainrecord/maintain-record-update-wx', this.dispatchFormData)
				.then(() => {
					this.$toast.success('保存成功')
					window.history.back()
				})
				.finally(() => {
					this.loading = false
				})
		}
	}
	async created() {
		this.id = this.$route.query.id
		if (this.id) {
			this.titletext = '编辑'
			this.isNew = false
			await this.getById(this.id)
		} else {
			this.titletext = '新增'
			this.isNew = true
		}
		await this.getSchoolList()
		await this.getCommonQuestionList()
		await this.getAssignByList()
		await this.getVehicleShortNO()

	}
	async mounted() {
		if (this.isNew) {
			this.dispatchFormData.handleType = '现场处理'
			this.maintainRecordTypeName = '驾培'
			this.dispatchFormData.acceptanceTime = util.nowDateTime()
			this.dispatchFormData.dispatchTime = util.nowDateTime()
		}
	}
}
